import dataBase from '@/dataBase/database'
import { motivationalReportService } from './motivationalReport.service'
import { config } from '@/_helpers'

export const offlineMotivationalReportService = {

  //получение мотивационного отчёта
  async getMotivationalReport(projectId, networkId, pointId) {
    if(navigator.onLine) {
      try {
        let data = await motivationalReportService.loadMyMotivation(projectId, networkId, pointId)

        if (data) {
          const existing = await dataBase.motivationalReport.where('serverId').equals(data.id).first()
          let localId
          if (existing && new Date(existing.createdAt).getMonth() == new Date().getMonth()) {
            await dataBase.motivationalReport.update(existing.id, {
              projectId: String(data.project.id),
              pointId:   String(data.tradePoint.id),
              createdAt: data.createDate,
              synced:    2,
              cachedAt:  new Date().toISOString(),
            })
            localId = existing.id
          } else {
            if( existing ){
              await this.deleteMotivationalDmp(existing)
              await dataBase.motivationalReport.where('serverId').equals(data.id).delete()
            }
            localId = await dataBase.motivationalReport.add({
              serverId:  data.id,
              projectId: String(data.project.id),
              pointId:   String(data.tradePoint.id),
              createdAt: data.createDate,
              synced:    2,
              cachedAt:  new Date().toISOString(),
            })
          }

          if (data.motivationalDmp && data.motivationalDmp.length) {
            await this.loadMotivationalDmp(data.motivationalDmp, localId)
          }
        }
        return data
      } catch (e) {
        console.log(e);
        console.warn('[offlineMotivationalReportService] getMotivationalReport: нет ответа, берём кэш')
      }
      
    }

    let motivationalReport = await dataBase.motivationalReport.where('pointId').equals(String(pointId)).first()
    if (!motivationalReport) {
      const localId = await dataBase.motivationalReport.add({
        serverId: null,
        projectId: String(projectId),
        networkId: String(networkId),
        pointId: String(pointId),
        synced: 0,
        cachedAt: new Date().toISOString(),
      });
      motivationalReport = await dataBase.motivationalReport.get(localId);
      motivationalReport.motivationalDmp = []
      return motivationalReport
    }
    let motivationalDmp = await dataBase.motivationalDmp.where('localMotivationalReportId').equals(Number(motivationalReport.id)).toArray()
    motivationalReport.motivationalDmp = []
    if(motivationalDmp && motivationalDmp.length) {
      for(const dmp of motivationalDmp) {
        const existing = await dataBase.motivationalDmpReport.where('localDmpId').equals(Number(dmp.id)).first()
        if(existing) dmp.reportDmp = existing
        else dmp.reportDmp = 'offline'
        
      }
      motivationalReport.motivationalDmp = motivationalDmp
    }
    return motivationalReport
  },

  async deleteMotivationalDmp(motivationalReportId) {
    let motivationalDmps = await dataBase.motivationalDmp.where('localMotivationalReportId').equals(Number(motivationalReportId)).toArray()
    for(let dmp of motivationalDmps) {
      await dataBase.photos.where('reportId').equals(`${dmp.localMotivationalReportId}_${dmp.id}`).delete()
      await dataBase.motivationalDmpReport.where('localDmpId').equals(Number(dmp.id)).delete()
    }
    await dataBase.motivationalDmp.where('localMotivationalReportId').equals(Number(motivationalReportId)).delete()
  },

  //подгрузка дмп
  async loadMotivationalDmp(motivationalDmp, motivationalReportId) {
    for (let dmp of motivationalDmp) {
      try {
        let existing = await dataBase.motivationalDmp.where('serverId').equals(dmp.id).first()

        if (existing) {
          await dataBase.motivationalDmp.update(existing.id, {
            dmpCategory:          dmp.dmpCategory,
            comment:              dmp.comment,
            localMotivationalReportId: Number(motivationalReportId),
            serverId:             dmp.id,
            synced:               1,
            cachedAt:             new Date().toISOString(),
          })
        } else {
          await dataBase.motivationalDmp.add({
            dmpCategory:          dmp.dmpCategory,
            comment:              dmp.comment,
            localMotivationalReportId: Number(motivationalReportId),
            serverId:             dmp.id,
            synced:               1,
            createdAt:            new Date().toISOString(),
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  
  //получение dmp категорий
  async loadCategories() {
    if(navigator.onLine) {
      try {
        let data = await motivationalReportService.loadDmpCategories()
        // await dataBase.dmpCategories.clear()
        // await dataBase.dmpCategories.bulkPut(
        //   data.map(c => ({ ...c,
        //     title: c.title, 
        //     cachedAt: new Date().toISOString() 
        //   }))
        // )
        return data
      } catch (e) {
        console.log(e);
        console.warn('[motivationalReportService] loadCategories: нет ответа, берём кэш')
      }
    }
    return dataBase.dmpCategories.toArray()
  },

  //создание dmp 
  async createDmp(motivationalDmp, motivationalReportId) {
    if(navigator.onLine) {
      return await motivationalReportService.createDmp(motivationalDmp, motivationalReportId)
    }

    let motivationalReport = await dataBase.motivationalDmp.add({
      dmpCategory: motivationalDmp.dmpCategory,
      comment: motivationalDmp.comment,
      localMotivationalReportId: Number(motivationalReportId),
      serverId: 0,
      synced: 0,
      cachedAt: new Date().toISOString() 
    })
    return dataBase.motivationalDmp.get(motivationalReport);
  },

  //загрузка формы отчета
  async loadReportForm(dmpId) {
    if(navigator.onLine) {
      try {
        let data = await motivationalReportService.loadDmpReport(dmpId)
        let localDmp = await dataBase.motivationalDmp.where('serverId').equals(Number(dmpId)).first()
        await dataBase.motivationalDmpReport.where('localDmpId').equals(Number(localDmp.id)).delete()
        await dataBase.motivationalDmpReport.add({
          localDmpId: Number(localDmp.id),
          dmpCategory: data.dmpCategory,
          synced: 2,
          cachedAt: new Date().toISOString()
        })

        if(data.reportPhotos && data.reportPhotos.length) {
          await dataBase.photos.where('reportId').equals(`${localDmp.localMotivationalReportId}_${localDmp.id}`).delete()
          for (const photo of data.reportPhotos) {
            const response = await fetch(config.image(photo.uuid))
            const arrayBuffer = await response.arrayBuffer();
            await dataBase.photos.add({
              reportId: `${localDmp.localMotivationalReportId}_${localDmp.id}`,
              uuid: photo.uuid,
              extension:  photo.extension,
              blob: arrayBuffer,
              synced: 2,
              dmp: photo.dmp,
              offline: false,
              motivational: photo.motivational,
              createdAt:  new Date().toISOString(),
            })
          }
        } else {
          await dataBase.photos.where('reportId').equals(`${localDmp.localMotivationalReportId}_${localDmp.id}`).delete()
        }
        return data
      } catch (error) {
        console.log(error);
        throw error;
      }
    }

    const existing = await dataBase.motivationalDmpReport.where('localDmpId').equals(Number(dmpId)).first()
    let reportId
    const dmp = await dataBase.motivationalDmp.get(dmpId)
    if(existing) {
      reportId = existing.id
    } else {
      reportId = await dataBase.motivationalDmpReport.add({
        localDmpId: Number(dmpId),
        dmpCategory: dmp.dmpCategory,
        synced: 2,
        cachedAt: new Date().toISOString()
      })
    }
    let cached = await dataBase.motivationalDmpReport.get(reportId)
    const photos = await dataBase.photos.where('reportId').equals(`${dmp.localMotivationalReportId}_${dmpId}`).toArray()
    cached.reportPhotos = []
    if(photos.length) {
      for (const photo of photos) {
        cached.reportPhotos.push(photo)
      }
    }
    return cached
  },

  //создание мотивационного отчета
  async saveDmpReport(dmpId, report) {
    if(navigator.onLine) {
      return motivationalReportService.sendReportDmp(dmpId, report)
    }
    const dmp = await dataBase.motivationalDmp.get(dmpId)
    for (let photo of (report.reportPhoto || [])) {
      if (photo.isOffline && photo.blob) {
        await dataBase.photos.add({
          reportId: `${dmp.localMotivationalReportId}_${dmpId}`,
          blob: photo.blob,
          motivational: photo.motivational,
          dmp: photo.dmp || false,
          fileName: photo.name,
          offline: true,
          synced: 0,
          createdAt: new Date().toISOString(),
        })
      }
    }
    const existing = await dataBase.motivationalDmpReport.where('localDmpId').equals(Number(dmpId)).first()
    let reportId

    if(existing) {
      await dataBase.motivationalDmpReport.update(existing.id, {
        dmpCategory: report.dmpCategory,
        synced: 0,
        cachedAt: new Date().toISOString()
      })
      reportId = existing.id
    } else {
      reportId = await dataBase.motivationalDmpReport.add({
        localDmpId: Number(dmpId),
        dmpCategory: report.dmpCategory,
        synced: 0,
        cachedAt: new Date().toISOString()
      })
    }

    return dataBase.motivationalDmpReport.get(reportId)
  },
  

}